/**
 * @generated SignedSource<<fc3f514c1b8fc23b442bac6c90faf10b>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173

import type { ConcreteRequest, Query } from 'relay-runtime';
export type WebItemLocationQuery$variables = {
  contentId?: string | null | undefined;
  location?: string | null | undefined;
  locations?: ReadonlyArray<string | null | undefined> | null | undefined;
  spaceKey?: string | null | undefined;
  version?: number | null | undefined;
};
export type WebItemLocationQuery$data = {
  readonly webItemSections: ReadonlyArray<{
    readonly cacheKey: string | null | undefined;
    readonly id: string | null | undefined;
    readonly items: ReadonlyArray<{
      readonly accessKey: string | null | undefined;
      readonly completeKey: string | null | undefined;
      readonly hasCondition: boolean | null | undefined;
      readonly icon: {
        readonly height: number | null | undefined;
        readonly path: string;
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly label: string | null | undefined;
      readonly moduleKey: string | null | undefined;
      readonly params: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly section: string | null | undefined;
      readonly styleClass: string | null | undefined;
      readonly tooltip: string | null | undefined;
      readonly url: string | null | undefined;
      readonly urlWithoutContextPath: string | null | undefined;
      readonly weight: number | null | undefined;
    } | null | undefined>;
    readonly label: string | null | undefined;
    readonly styleClass: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type WebItemLocationQuery = {
  response: WebItemLocationQuery$data;
  variables: WebItemLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "location"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locations"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "label"
},
v7 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v8 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "location",
        "variableName": "location"
      },
      {
        "kind": "Variable",
        "name": "locations",
        "variableName": "locations"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "version"
      }
    ],
    "concreteType": "WebSection",
    "kind": "LinkedField",
    "name": "webItemSections",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "kind": "ScalarField",
        "name": "cacheKey"
      },
      (v7/*: any*/),
      {
        "concreteType": "WebItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accessKey"
          },
          {
            "kind": "ScalarField",
            "name": "completeKey"
          },
          {
            "kind": "ScalarField",
            "name": "hasCondition"
          },
          (v5/*: any*/),
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "height"
              },
              {
                "kind": "ScalarField",
                "name": "width"
              },
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          },
          {
            "concreteType": "MapOfStringToString",
            "kind": "LinkedField",
            "name": "params",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          },
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "moduleKey"
          },
          {
            "kind": "ScalarField",
            "name": "section"
          },
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "tooltip"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "urlWithoutContextPath"
          },
          {
            "kind": "ScalarField",
            "name": "weight"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WebItemLocationQuery",
    "selections": (v8/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "WebItemLocationQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "0006505c7639efb87b37fdf9e06ba577",
    "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
    "metadata": {},
    "name": "WebItemLocationQuery",
    "operationKind": "query",
    "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
  }
};
})();

(node as any).hash = "8e88912bf23040d88bbeb5c8cadae7c2";

export default node;
